// var baseUrl ='http://10.161.59.10' // 杨志
// var baseUrl ='http://10.161.120.70:7008' // 王文博
// var baseUrl ='http://10.161.37.168' // 王宇
// var baseUrl ='http://10.161.46.41:7008' // 黎伟荣
// var baseUrl ='http://10.161.46.41' // 黎伟荣
// var baseUrl ='http://10.161.44.170' // 庞海藏
// var baseUrl ='http://10.161.40.49:7008' // 吴思雨

// var baseUrl = 'https://yizhuang-stg.yun.city.pingan.com:30001/ipark/'
// var baseUrl = 'https://yizhuang-stg.yun.city.pingan.com:30001'
// var baseUrl = 'http://yizhuang.base-stg.yun.city.pingan.com'
// var baseUrl = 'https://isp.tml-itcity.com'
// var baseUrl = 'http://10.161.61.189:7008'

// var baseUrl = 'https://isp.tml-itcity.com/ipark/'
// var baseUrl = 'http://10.161.120.195:8001'
// var baseUrl = 'http://123.117.129.158'
var baseUrl = 'http://localhost:8883'


module.exports = baseUrl



// WEBPACK FOOTER //
// ./config/baseUrl.js